import salomonImg from '../assets/salomonDelgado.png';
import juanImg from '../assets/juanJose.png';
import nicolasImg from '../assets/nicolasGonzales.png';
import cristianImg from '../assets/cristian.webp';
import diegoImg from '../assets/diego.png';
import senseiImg from '../assets/sensei.jpg';
import marceloImg from '../assets/marcelo.webp';
export const whatsappNumber = '573222177326';

export const waLink = (mensaje) =>
  `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(mensaje)}`;

export const waMessages = {
  general:
    'Hola, Sensei Cristhian. Vi la página del Centro de Entrenamiento Kamae y quiero agendar mi primera clase. ¿Me cuenta los horarios y el proceso de inscripción?',
  karate:
    'Hola, Sensei Cristhian. Vi la página del Centro de Entrenamiento Kamae y me interesan las clases de Karate Do Shito Ryu ($140.000/mes). ¿Qué horarios tiene disponibles y qué necesito para empezar?',
  gym:
    'Hola, Sensei Cristhian. Vi la página del Centro de Entrenamiento Kamae y me interesa la preparación física en el gimnasio ($130.000/mes). ¿Qué horarios manejan y cómo es el entrenamiento dirigido?',
  combo:
    'Hola, Sensei Cristhian. Vi la página del Centro de Entrenamiento Kamae y me interesa el combo de Karate + preparación física ($210.000/mes). ¿Me cuenta los horarios y cómo empezar?',
};

export const navLinks = [
  { href: '#inicio', label: 'Inicio' },
  { href: '#sensei', label: 'Sensei' },
  { href: '#senpais', label: 'Senpais' },
  { href: '#podio', label: 'Podio' },
  { href: '#shitoryu', label: 'Shito Ryu' },
];

export const senpais = [
  { name: 'Salomón Delgado', belt: 'Cinta Negra', beltColor: '#000000ff', image: salomonImg, objectPosition: 'center 30%' },
  { name: 'Marcelo Bravo', belt: 'Cinta Marrón', beltColor: '#7A4521', image: marceloImg, objectPosition: 'center -5%' },
  { name: 'Juan José', belt: 'Cinta Marrón', beltColor: '#7A4521', image: juanImg, objectPosition: 'center 9%' },
  { name: 'Cristian David', belt: 'Cinta Marrón', beltColor: '#7A4521', image: cristianImg, objectPosition: 'center 03%' },
  { name: 'Nicolas Gonzales', belt: 'Cinta Marrón', beltColor: '#7A4521', image: nicolasImg, objectPosition: 'center 8%' },
];

export const gymTrainers = [
  { name: 'Cristhian Toro', role: 'Sensei del dojo · Karate Do', image: senseiImg, objectPosition: 'center 20%' },
  // `cutout`: la foto viene recortada sobre fondo transparente.
  { name: 'Diego', role: 'Entrenador del gimnasio', image: diegoImg, cutout: true },
];

export const senseiCredentials = [
  { title: 'Cinta Negra Shito Ryu', subtitle: '2° Dan · FCK' },
  { title: 'Examinador Oficial', subtitle: 'Federación Colombiana' },
  { title: 'Entrenador Deportivo', subtitle: 'Certificado COLEF', wide: true },
];

export const shitoRyuPillars = [
  {
    kanji: '技',
    title: 'Técnica precisa',
    text: 'Cada movimiento responde a una intención. La forma antes que la fuerza.',
  },
  {
    kanji: '礼',
    title: 'Respeto y disciplina',
    text: 'El dojo se entra y se sale con una reverencia. El carácter se forja aquí.',
  },
  {
    kanji: '道',
    title: 'El camino (Do)',
    text: 'No es un destino sino una práctica de por vida. Progreso constante.',
  },
];

export const contactInfo = [
  {
    label: 'Ubicación',
    title: 'Avenida Libertadores 18N - 121',
    subtitle: 'Barrio Santa Helena · Diagonal al Unicentro · Cúcuta',
    href: 'https://share.google/vvKA2winPzmMl2e8x',
    linkLabel: 'Ver en Google Maps',
  },
  {
    label: 'Sensei',
    title: 'Cristhian Toro',
    subtitle: '322 217 7326',
  },
  {
    label: 'Instagram',
    title: '@dojokamae',
  },
  {
    label: 'Certificación',
    title: 'Federación Colombiana',
    subtitle: 'de Karate Do',
  },
];

export const heroStats = [
  { value: '2', label: 'Disciplinas' },
  { value: '2°', valueSuffix: 'Dan', label: 'Cinta Negra FCK' },
  { value: 'GYM', label: 'Preparación física' },
];

export const gymSchedules = [
  {
    group: 'Preparación Física · Entrenamientos dirigidos',
    ages: 'Niños y adolescentes',
    days: 'Lunes a Viernes',
    hours: '5:30 - 7:30 am · 3:00 - 4:00 pm · 4:00 - 5:00 pm · 5:00 - 6:00 pm · 6:00 - 7:00 pm',
  },
  {
    group: 'Karate Do',
    ages: 'Todas las edades',
    days: 'Lunes a Viernes',
    hours: '3:00 - 4:00 pm · 4:00 - 5:30 pm · 5:30 - 7:00 pm · 7:00 - 8:15 pm',
  },
];

export const gymPricing = [
  { program: 'Karate Do', ages: 'Matrícula gratis · Hermanos $125.000 c/u', price: '$140.000', period: '/mes' },
  { program: 'Preparación Física', ages: 'Entrenamientos dirigidos · Gym', price: '$130.000', period: '/mes' },
  { program: 'Combo', ages: 'Karate + preparación física', price: '$210.000', period: '/mes' },
];

export const gymBenefits = [
  'Fomenta la disciplina y la responsabilidad',
  'Desarrolla hábitos saludables desde temprana edad',
  'Mejora la coordinación, el equilibrio, la fuerza y la velocidad',
  'Aumenta la confianza y la autoestima',
  'Enseña el valor del esfuerzo y la perseverancia',
  'Fortalece la concentración y el autocontrol',
  'Promueve el respeto, el trabajo en equipo y la sana convivencia',
  'Reduce el sedentarismo y fortalece el cuerpo de manera segura',
  'Programas de alto rendimiento para niños deportistas: potencia capacidades, previene lesiones y mejora resultados',
];